module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('basic-info-section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.organization_id),
      expression: "project.organization_id"
    }],
    attrs: {
      "project": _vm.project,
      "errors": _vm.errors,
      "submit": _vm.submit
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.organization_id),
      expression: "project.organization_id"
    }],
    staticClass: "container profile-details rais your-campaign-details",
    attrs: {
      "id": "scrollTo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.showDetails) ? _c('div', {
    key: "details",
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist",
      "id": "raistabs"
    }
  }, [_c('li', [_c('a', {
    staticClass: "first uppercase"
  }, [_vm._v(_vm._s(_vm.$t("project.details")))])]), _vm._v(" "), _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#your-campaign-basics",
      "aria-controls": "profile-about",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.$t("project.basics")))])]), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.isNewProject()
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    ref: "reward",
    attrs: {
      "href": "#your-campaign-story",
      "aria-controls": "profile-campaigns",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [(_vm.isNewProject()) ? _c('tooltip', {
    attrs: {
      "title": 'add rewards for your project in next step'
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rewards")) + "\n                ")]) : _c('p', [_vm._v(_vm._s(_vm.$t("rewards")))])], 1)]), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.isNewProject()
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#your-campaign-team",
      "aria-controls": "profile-contributions",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [(_vm.isNewProject()) ? _c('tooltip', {
    attrs: {
      "title": 'finish this step to invite friends to your campaign'
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("team.team")) + "\n                ")]) : _c('p', [_vm._v(_vm._s(_vm.$t("team.team")))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "role": "tabpanel",
      "id": "your-campaign-basics"
    }
  }, [(_vm.isNewProject() || _vm.project.id) ? _c('details-section', {
    attrs: {
      "project": _vm.project,
      "submit": _vm.submit,
      "alert": _vm.alert
    },
    on: {
      "update:project": function($event) {
        _vm.project = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.isNewProject()) ? _c('div', {
    staticClass: "tab-pane fade disabled",
    attrs: {
      "role": "tabpanel",
      "id": "your-campaign-story"
    }
  }, [_c('rewards-section', {
    attrs: {
      "project": _vm.project
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNewProject()) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel",
      "id": "your-campaign-team"
    }
  }, [_c('team-section', {
    attrs: {
      "project": _vm.project
    }
  })], 1) : _vm._e()])]) : _c('div', {
    key: "info"
  }, [_c('h2', [_vm._v("In next step you can add more detais about your project")])])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c36287"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Fundraising/Form.vue
// module id = 782
// module chunks = 1